// src/services/VehicleAdminService.js
import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors";
import { HTTP, BACKEND_API_URL } from "@/utils/http-common";

// map des colonnes UI -> champs d'ordering côté API/DRF
function mapSortField(uiField) {
  switch (uiField) {
    case "user":         return "user__fullname";
    case "plate_number": return "plate_number";
    case "vehicle_type": return "vehicle_type";
    case "is_active":    return "is_active";
    case "is_default":   return "is_default";
    case "created_at":   return "created_at";
    default:             return "created_at";
  }
}

export default {
  async list({ page = 1, itemsPerPage = 10, sortBy = [], sortDesc = [], search = "", status = "pending", start_date, end_date, user_type, vehicle_type, station } = {}) {
    const params = { page, page_size: itemsPerPage, status };
    if (sortBy && sortBy.length) {
      const field = mapSortField(sortBy[0]);
      params.ordering = (sortDesc && sortDesc[0]) ? `-${field}` : field;
    }
    if (search) params.search = search;
    if (start_date) params.start_date = start_date;
    if (end_date) params.end_date = end_date;
    if (user_type) params.user_type = user_type;
    if (vehicle_type) params.vehicle_type = vehicle_type;
    if (station) params.station = station;

    try {
      const { data } = await HTTP.get(`/activity/vehicles`, { params });
      const items = Array.isArray(data) ? data : (data?.results || []);
      const count = Array.isArray(data) ? items.length : (data?.count || 0);
      const stats = data?.stats || null;
      return { items, count, stats };
    } catch (e) {
      new EHC(DEFAULTS_HANDLERS).intercept(e);
      throw e;
    }
  },

  /**
   * Vérifie si un numéro de plaque existe déjà dans le système B2B
   * @param {string} plateNumber - Numéro de plaque à vérifier
   * @param {string|number} userId - ID de l'utilisateur (pour exclure ses propres véhicules)
   * @returns {Promise<object>} - { exists: boolean, source?: string, vehicle?: object }
   */
  async checkPlateNumber(plateNumber, userId = null) {
    try {
      const payload = { plate_number: plateNumber };
      if (userId) {
        payload.user_id = userId;
      }
      
      const { data } = await HTTP.post('/activity/vehicles/check-plate', payload);
      return data;
    } catch (e) {
      new EHC(DEFAULTS_HANDLERS).intercept(e);
      throw e;
    }
  },

  
  /**
   * Met à jour le type d'un véhicule
   * @param {string|number} vehicleId - ID du véhicule
   * @param {object} data - Données contenant le nouveau vehicle_type
   * @returns {Promise}
   */
      // src/services/VehicleAdminService.js
    async updateVehicleType(vehicleId, data) {
      try {
        const { data: res } = await HTTP.patch(
          `/activity/vehicles/${vehicleId}/change-type`,
          data
        );
        return res;
      } catch (e) {
        new EHC(DEFAULTS_HANDLERS).intercept(e);
        throw e;
      }
    },




  async setActive(id, is_active) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/activity/vehicles/${id}`, { is_active })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e); });
    });
  },

  async approve(id) {
    try {
      const { data } = await HTTP.patch(`/activity/vehicles/${id}`, { decision_status: true });
      return data;
    } catch (e) { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e; }
  },
  async reject(id) {
    try {
      const { data } = await HTTP.patch(`/activity/vehicles/${id}`, { decision_status: false });
      return data;
    } catch (e) { new EHC(DEFAULTS_HANDLERS).intercept(e); throw e; }
  },

  async setDefault(id) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/activity/vehicles/${id}`, { is_default: true })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e); });
    });
  },

  async delete(id) {
    const { data } = await HTTP.delete(`/activity/vehicles/${id}`);
    return data;
  },

  async exportFidelityUsers() {
    const token = (await import("@/store")).default.state.app.user?.key;
    const headers = {};
    if (token) headers.authorization = "Token " + token;
    const axios = (await import("axios")).default;
    const response = await axios.get(BACKEND_API_URL + "/activity/vehicles/export-users", {
      responseType: "blob",
      headers,
    });
    return response.data;
  },

  async exportVehicleValidations(params = {}) {
    const token = (await import("@/store")).default.state.app.user?.key;
    const headers = {};
    if (token) headers.authorization = "Token " + token;
    const axios = (await import("axios")).default;
    const queryParams = new URLSearchParams(params).toString();
    const url = BACKEND_API_URL + `/activity/vehicles/export-validations${queryParams ? '?' + queryParams : ''}`;
    const response = await axios.get(url, {
      responseType: "blob",
      headers,
    });
    return response.data;
  },

  downloadUserCompanyPoints($) {
    return new Promise((resolve, reject) => {
      const url = `${BACKEND_API_URL}/activity/user-company-points/export/`;

      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);

      // mêmes headers que ton downloadFile
      const user = $.$store.state.app.user;
      if (user && user.key) {
        xhr.setRequestHeader("authorization", "Token " + user.key);
      }
      if (user && user.tzName) {
        xhr.setRequestHeader("X-Timezone-Name", user.tzName);
      }

      xhr.responseType = "blob";

      xhr.onload = function () {
        if (xhr.status === 200) {
          resolve(xhr.response);   // <-- blob CSV
        } else {
          reject(xhr);
        }
      };

      xhr.onerror = function () {
        reject(xhr);
      };

      xhr.send();
    }).catch(e => {
      // on passe quand même par ton gestionnaire d’erreurs
      new EHC(DEFAULTS_HANDLERS).intercept(e);
      throw e;
    });
  },


};
